// src/components/AccountChecker/SearchOptions.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SearchOptions = ({ options, onOptionChange, disabled = false }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const databases = [
    {
      id: 'all',
      title: isEn ? 'All Databases' : 'Все Базы Данных',
      sub: isEn ? 'Compromised accounts' : 'Скомпрометированные аккаунты',
    },
    {
      id: 'recent',
      title: isEn ? 'Recent Leaks Only' : 'Только Недавние Утечки',
      sub: isEn ? 'Fresh dumps (fresh, 90 days)' : 'Свежие дампы (свежие, 90 дней)',
    },
    {
      id: 'verified',
      title: isEn ? 'Verified Accounts Only' : 'Только Проверенные Аккаунты',
      sub: isEn ? 'Validated by bots' : 'Валидированные ботами',
    },
  ];

  return (
    <aside className={`glass-card-module ${disabled ? 'is-disabled' : ''}`}>
      {/* Шапка карточки в едином стиле с RconAudit и DataExtraction */}
      <div className="card-heading">
        <div className="card-title-wrap">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="4" y1="21" x2="4" y2="14" />
            <line x1="4" y1="10" x2="4" y2="3" />
            <line x1="12" y1="21" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12" y2="3" />
            <line x1="20" y1="21" x2="20" y2="16" />
            <line x1="20" y1="12" x2="20" y2="3" />
            <line x1="1" y1="14" x2="7" y2="14" />
            <line x1="9" y1="8" x2="15" y2="8" />
            <line x1="17" y1="16" x2="23" y2="16" />
          </svg>
          <h3 className="card-title">
            {isEn ? 'Search Settings' : 'Настройки поиска'}
          </h3>
        </div>
      </div>

      {/* 1. БАЗЫ ДАННЫХ (в стиле DataExtraction extract-item-label) */}
      <div className="field-group" style={{ marginBottom: '18px' }}>
        <label className="field-label">
          {isEn ? 'DATABASE SELECTION' : 'База данных'}
        </label>

        <div className="search-options-stack">
          {databases.map((db) => {
            const isSelected = (options.database || 'all') === db.id;
            return (
              <label
                key={db.id}
                className={`search-option-card ${isSelected ? 'selected' : ''} ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
                onClick={() => !disabled && onOptionChange('database', db.id)}
              >
                <div className="option-card-left">
                  <div className="option-checkbox-indicator">
                    <svg viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <div className="option-card-texts">
                    <span className="option-card-title">{db.title}</span>
                    <span className="option-card-sub">{db.sub}</span>
                  </div>
                </div>
              </label>
            );
          })}
        </div>
      </div>

      {/* 2. ТИП ПОИСКА (объединённый segmented pill) */}
      <div className="field-group" style={{ marginBottom: '18px' }}>
        <label className="field-label">
          {isEn ? 'SEARCH TYPE' : 'Тип поиска'}
        </label>

        <div className="match-type-presets">
          <button
            type="button"
            disabled={disabled}
            className={`match-preset-btn ${(options.searchType || 'exact') === 'exact' ? 'active' : ''}`}
            onClick={() => !disabled && onOptionChange('searchType', 'exact')}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>{isEn ? 'Exact Match' : 'Точное Совпадение'}</span>
          </button>
          <button
            type="button"
            disabled={disabled}
            className={`match-preset-btn ${options.searchType === 'fuzzy' || options.searchType === 'similar' ? 'active' : ''}`}
            onClick={() => !disabled && onOptionChange('searchType', 'fuzzy')}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <span>{isEn ? 'Similar Names' : 'Похожие Имена'}</span>
          </button>
        </div>
      </div>

      {/* 3. ВЫБОР МАКСИМАЛЬНОГО КОЛИЧЕСТВА РЕЗУЛЬТАТОВ (в стиле RconAudit thread pills) */}
      <div className="field-group" style={{ marginBottom: '4px' }}>
        <label className="field-label">
          {isEn ? 'MAX RESULTS LIMIT' : 'Лимит вывода'}
        </label>

        <div className="results-limit-pills">
          {[25, 50, 100, 'all'].map((val) => {
            const isSelected = options.maxResults === val || (val === 'all' && (options.maxResults === 0 || options.maxResults === 'all'));
            return (
              <button
                key={String(val)}
                type="button"
                disabled={disabled}
                className={`limit-pill-btn ${isSelected ? 'active' : ''}`}
                onClick={() => !disabled && onOptionChange('maxResults', val)}
              >
                {val === 'all' ? (isEn ? 'All' : 'Все') : val}
              </button>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export default SearchOptions;